import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Merchant {
  id: string
  email: string
  name?: string
  twoFactorEnabled?: boolean
}

interface AuthState {
  token: string | null
  merchant: Merchant | null
  isAuthenticated: boolean
  setAuth: (token: string, merchant: Merchant) => void
  updateTwoFactorEnabled: (enabled: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      merchant: null,
      isAuthenticated: false,

      setAuth: (token: string, merchant: Merchant) => {
        set({
          token,
          merchant,
          isAuthenticated: true,
        })
      },

      updateTwoFactorEnabled: (enabled: boolean) => {
        set((state) => ({
          merchant: state.merchant ? { ...state.merchant, twoFactorEnabled: enabled } : null,
        }))
      },

      logout: () => {
        set({
          token: null,
          merchant: null,
          isAuthenticated: false,
        })
      },
    }),
    {
      name: 'kyren-auth',
      partialize: (state) => ({
        token: state.token,
        merchant: state.merchant,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
)
